import consentApi from '@/modules/consent-api';
 
export default {
	setMarketingFlag(payload){
		return consentApi.setMarketingFlag(payload);
	},

	getMarketingFlag(){
		return consentApi.getMarketingFlag();
	}
};



// WEBPACK FOOTER //
// ./src/modules/consent-service.js